const religion = [
    { id: 'Baha-i', name: 'Baha’i' },
    { id: 'buddhism', name: 'Buddhism' },
    { id: 'candomble', name: 'Candomblé' },
    { id: 'christianity', name: 'Christianity' },
    { id: 'hinduism', name: 'Hinduism' },
    { id: 'islam', name: 'Islam' },
    { id: 'jainism', name: 'Jainism' },
    { id: 'judaism', name: 'Judaism' },
    { id: 'rastafari', name: 'Rastafari' },
    { id: 'shinto', name: 'Shinto' },
    { id: 'sikhism', name: 'Sikhism' },
    { id: 'taoism', name: 'Taoism' }
];

export default religion;
